import React, {useEffect, useState, useRef} from 'react';

import Close from "../assets/Close.svg"
import styled, {css} from 'styled-components/macro'
import {AnimatePresence, motion} from "framer-motion";
import Spinner from "./Spinner";

const CloseMarketButton = styled(motion.button)`    
    width: 25%;
    min-width: 95px;
    height: 30px;
    margin-top: 5px;
    margin-right: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    
    border: 1px solid #FAAD16;
    box-sizing: border-box;
    border-radius: 41px;
    background: transparent;
    color: #FAAD16;
    font-style: normal;
    font-weight: bold;
    font-size: 10px;
    line-height: 180%;
    
    cursor: pointer;
`


const Popup = styled(motion.div)`
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0px;
    left: 0px;
    background: rgba(0, 0, 0, 0.75);
    text-align: center;
    z-index: 3;
`

const PopupInner = styled(motion.div)`
    text-align: left;
    vertical-align: middle;
    position: absolute;
    max-width: 700px;
    width: 671px;
    top:50%;
    left:50%;
    transform: translate(-50%, -50%);
    padding: 40px;
    z-index: 4;
    
    background: #FFFFFF;
    box-shadow: 0px 8px 36px rgba(0, 0, 0, 0.16);
    border-radius: 16px;
    
    text-align: center;


`

const PopupHeader = styled.div`
    width: 100%;
    height: 24px;
    font-size: 19px;
    left: calc(50% - 623px/2);
    top: calc(50% - 24px/2 - 10px);
    line-height: 24px;
    font-weight: bold;
    display: flex;
    flex-direction: row;
    align-items: center;
    text-transform: capitalize;
`

const CloseButton = styled.a`
    width: 24px;
    margin-left: auto;
    height: 24px;
    cursor: pointer;
`

const ContentArea = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 40px;    
`

const PopupFooter = styled.div`
    display: flex;
    flex-direction: row;
    margin-top: 40px;

`

const PopupButton = styled.a`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    
    
    position: relative;
    width: 300px;
    height: 42px;
    margin: 15px;
    background: transparent;
    color: #FAC44E;
    border: 2px solid #FAC44E;

    border-radius: 30px;
    ${props => props.primary && css`
        background: #FAC44E;
        color: white;
    `}
    
    cursor: pointer;
`

const NotificationBox = styled.div`
    background: rgba(250, 173, 22, 0.1);
    border-radius: 6px;
    
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    
    padding: 15px 16px;

    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    
    text-align: left;    
`

const modalVariant = {
    initial: { opacity: 0 },
    isOpen: { opacity: 1 },
    exit: { opacity: 0 }
};
const containerVariant = {
    initial: { top: "-50%", transition: { type: "spring" } },
    isOpen: { top: "50%" },
    exit: { top: "-50%" }
};

const CloseMarketModal = (props) => {
    const [modal, setModal] = useState(false);
    const [loanPoolID, setLoanPoolID] = useState(props.loanPoolID);

    const [loading, setLoading] = useState(false);

    const Notification = props.status == "0" ?
        (
            <NotificationBox>
                You are attempting to close the market '{props.loanPoolName}'.
                <br/>
                <br/>
                When the market is closed, users can no longer deposit into this market and new loans can not be created from this market.
                <br/>
                <br/>
                Users can still redeem their aeTokens and existing loans can be paid.
            </NotificationBox>
        ) :
        (
            <NotificationBox>
                You are attempting to reopen the market '{props.loanPoolName}'.
                <br/>
                <br/>
                When the market is reopen, users will be able to deposit into this market again. New loans can be created from this market.
                <br/>
                <br/>
                Users can still redeem their aeTokens and existing loans can be paid.
            </NotificationBox>
        );

    const ButtonLabel = props.status === "0" ? "Close Market" : "Reopen Market";
    const Action = props.status === "0" ? "Close" : "Reopen";

    const toggle = () => {
        setLoading(false);
        setModal(!modal);
    };

    return (
        <AnimatePresence>
            <CloseMarketButton
                key={"closeMarketButton"}
                onClick={toggle}
                whileHover={{scale: 1.1}}
                whileTap={{scale: 0.9}}>
                {ButtonLabel.toUpperCase()}
            </CloseMarketButton>
            {
                modal && (
                    <Popup
                        key={"popup-closeMarket"}
                        initial={"initial"}
                        animate={"isOpen"}
                        exit={"exit"}
                        variants={modalVariant}
                    >
                        <PopupInner
                            key={"popupInner-closeMarket"}
                            variants={containerVariant}>
                            <PopupHeader>
                                {Action} Market '{props.loanPoolName}'
                                <CloseButton onClick={toggle}><img src={Close}/></CloseButton>
                            </PopupHeader>
                            { loading ? (<Spinner/>): (
                                <ContentArea>
                                    {Notification}
                                </ContentArea>
                            )}
                            <PopupFooter>
                                <PopupButton onClick={toggle}>Cancel</PopupButton>
                                <PopupButton onClick={() => {
                                    setLoading(true);
                                    props.action(loanPoolID).catch(()=>{
                                        setLoading(false);
                                })}
                                }primary>{ButtonLabel}</PopupButton>
                            </PopupFooter>
                        </PopupInner>
                    </Popup>
                )
            }
        </AnimatePresence>
    );
};

export default CloseMarketModal;
